.root {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--paletteNeutral0);
  padding: var(--spacingSm);
}

.valuesContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
